/* WS-FUNNEL2: recently viewed rail. Vanilla, deferred. localStorage key fnl_rv_v1 (handle, title, url, image, price of formulas this shopper opened). */
(function () {
  'use strict';
  var K = 'fnl_rv_v1', MAX = 8, d = document;
  function read() { try { var a = JSON.parse(window.localStorage.getItem(K)); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function write(a) { try { window.localStorage.setItem(K, JSON.stringify(a)); } catch (e) {} }
  function ok(x) { return x && typeof x.h === 'string' && typeof x.t === 'string' && /^\/products\/[a-z0-9-]+$/.test(x.u || '') && /^https:\/\/cdn\.shopify\.com\//.test(x.i || ''); }
  function init() {
    var sec = d.querySelector('[data-fnl-rv]'); if (!sec) return;
    var cur = { h: sec.getAttribute('data-h'), t: sec.getAttribute('data-t'), u: sec.getAttribute('data-u'), i: sec.getAttribute('data-i'), p: sec.getAttribute('data-p') };
    if (!ok(cur)) return;
    var prev = read().filter(function (x) { return ok(x) && x.h !== cur.h; });
    var list = sec.querySelector('[data-fnl-rv-list]');
    prev.slice(0, 3).forEach(function (x) {
      var li = d.createElement('li'), a = d.createElement('a'), im = d.createElement('img'), n = d.createElement('span'), p = d.createElement('span');
      a.className = 'fnl-rv__item'; a.href = x.u; a.setAttribute('data-pl-cta', 'recent_rail');
      im.className = 'fnl-rv__img'; im.src = x.i; im.alt = ''; im.width = 72; im.height = 72; im.loading = 'lazy';
      n.className = 'fnl-rv__name'; n.textContent = x.t; p.className = 'fnl-rv__price'; p.textContent = x.p || '';
      var box = d.createElement('span'); box.style.display = 'grid'; box.appendChild(n); box.appendChild(p);
      a.appendChild(im); a.appendChild(box); li.appendChild(a); list.appendChild(li);
    });
    if (prev.length) sec.hidden = false;
    write([cur].concat(prev).slice(0, MAX));
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
